export default "__VITE_ASSET__DhOq3ppO__"